import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretRightDouble12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCaretRightDouble12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.353 1.146a.5.5 0 0 0-.707.708L9.793 6l-4.147 4.147a.5.5 0 0 0 .707.707l4.5-4.5.354-.354-.353-.354zm-4.443.058a.5.5 0 1 0-.707.707l4.09 4.09-4.088 4.088a.5.5 0 1 0 .707.707l4.442-4.442.353-.353-.353-.354z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretRightDouble12);
